import styled, { css } from 'styled-components';
import { ReactNode } from 'react';

const Button = styled.button`
  ${(props) => css`
    border: solid 1px ${props.theme.colors.background};
    padding: ${props.theme.space['2xs']} ${props.theme.space['s']};
    border-radius: ${props.theme.sizes['-4']};
    background-image: linear-gradient(
      270.98deg,
      #ffcd4d -5.71%,
      #fa43bd 102.6%
    );
    color: ${props.theme.colors.text};
  `}

  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.spark.black};
    border-color: ${(props) => props.theme.colors.background};
  }

  &:disabled {
    background-color: transparent;
    background-image: unset;

    ${(props) => css`
      border-color: ${props.theme.colors.border};
      color: ${props.theme.colors.muted};
    `}

    &:hover {
      cursor: not-allowed;
    }
  }
`;

export interface ApplyButtonProps {
  children: ReactNode | ReactNode[];
}

export default function ApplyButton({ children, ...rest }: ApplyButtonProps) {
  return <Button {...rest}>{children}</Button>;
}
